import type { Message } from '@/types'

// ─────────────────────────────────────────────
// UserMessage
// Right-aligned blue bubble for user messages.
// ─────────────────────────────────────────────

interface Props {
  message: Message
}

export function UserMessage({ message }: Props) {
  const time = message.timestamp.toLocaleTimeString([], {
    hour:   '2-digit',
    minute: '2-digit',
  })

  return (
    <div className="flex justify-end mb-3">
      <div className="max-w-[80%] flex flex-col items-end gap-1">
        <div
          className="
            px-4 py-2.5 rounded-2xl rounded-tr-sm
            text-sm leading-relaxed whitespace-pre-wrap break-words
            bg-[var(--color-msg-user)]
            text-[var(--color-msg-user-text)]
          "
        >
          {message.content}
        </div>
        <span className="text-[11px] text-[var(--color-text-sub)] pr-1">
          {time}
        </span>
      </div>
    </div>
  )
}